<template>
  <v-container fluid grid-list-lg>

    <h2>{{ $t("creators") }}</h2>
    <v-divider class="mb-3"></v-divider>

    <v-alert
      v-if="empty"
      :value="true"
      color="warning"
      icon="priority_high"
      outline
    >
      {{ $t("no-creator") }}
    </v-alert>

    <div class="text-xs-center" v-if="length > 1">
      <v-pagination
        v-model="page"
        :length="length"
        total-visible=5
        color="#000"
        @input="nextPage"
      ></v-pagination>
    </div>

    <v-layout row wrap class="ss-layout">
      <v-flex xs12 sm6 md4 lg3 xl2 v-for="(creator, key) in creators" :key="key">
        <v-card class="ss-card" :to="'/creator/' + creator.creators_id">
          <v-responsive :aspect-ratio="1/1">
            <v-img :src="'/service/img/public/creators/' + creator.creators_img" aspect-ratio="1" class="ss-card-img"></v-img>
          </v-responsive>
          <div class="ss-card-title2 text-truncate">{{ creator.creators_first_name }} {{ creator.creators_last_name }}</div>
          <div class="subheading text-truncate">{{ creator.creators_details_introduction }}</div>
        </v-card>
      </v-flex>
    </v-layout>

    <div class="text-xs-center" v-if="length > 1">
      <v-pagination
        v-model="page"
        :length="length"
        total-visible=5
        color="#000"
        @input="nextPage"
      ></v-pagination>
    </div>

  </v-container>
</template>
<script>
  export default {
    data() {
      return {
        page: 1,
        length: 0,
        creators: [],
        empty: false,
      }
    },
    created() {
      this.$emit('getAuth');
      this.getCreators();
    },
    computed: {
      locale: {
        get:function () { return this.$store.state.locale }
      }
    },
    watch: {
      locale: function() {
        this.getCreators();
      }
    },
    methods: {
      nextPage(page) {
        this.page = page;
        this.getCreators(true);
      },
      getCreators(scrollTop) {
        this.$axios.get("/service/api/public/creators/" + this.page)
          .then(response =>  {
            this.creators = response.data.creators;
            if(this.creators.length === 0) {
              this.empty = true;
            }
            this.length = response.data.length;
            if(scrollTop) {
              window.scroll(0, 0);
            }
          }).catch(error => {
            this.$emit('showNotification', 'error', error.response.data.error.message);
          });
      },
    }
  }
</script>